import React, { useState } from "react";
import "./FilterSection.scss";
import { useNavigate } from "react-router-dom";
import "rsuite/dist/rsuite.min.css";
import Headings from "../Headings/Headings";
import AuiButton from "../Buttons/Buttons";
import { useRBACContext } from "@impelsysinc/react-rbac";
import OrganisationFilter from "../../pages/CourseListing/OrganisationFilter/OrganisationFilter";
import { AdminRoles, adminRoleStatusFilters } from "../../utils/constants/app-constants";
import DropDown from "../DropDown/DropDown";
import SearchInput from "../SearchInput/SearchInput";

interface CourseOption {
  label: string;
  value: string;
}
interface FilterSectionProps {
  setCourseType: (courseType: CourseOption) => void;
  setStatusType: (statusType: CourseOption) => void;
  setCurrentPage: (page: number) => void;
  setCollabOrg: (orgType: CourseOption) => void;
  setClassType: (classType: CourseOption) => void;
  setCourseSearchTerm: (val: string) => void;
}
const FilterSection: React.FC<FilterSectionProps> = ({
  setCourseType,
  setStatusType,
  setCurrentPage,
  setCollabOrg,
  setClassType,
  setCourseSearchTerm,
}) => {
  const navigate = useNavigate();
  const { canAccess } = useRBACContext();
  const [filtercourseType, setFiltercourseType] = useState<CourseOption>({
    label: "",
    value: "",
  });
  const [filterStatusType, setFilterStatusType] = useState<CourseOption>({
    label: "",
    value: "",
  });
  const [collabOrganisation, setCollabOrganisation] = useState<CourseOption>({
    label: "",
    value: "",
  });
  const [filterclassType, setFilterclassType] = useState<CourseOption>({
    label: "",
    value: "",
  });
  const canAccessCourse = canAccess({
    action: "*",
    resource: "course",
  });
  const canAccessOrg = canAccess({
    action: ["get", "get.all"],
    resource: "organisation",
  });
  const courseDropdownOptions = [
    { label: "BEC", value: "BEC" },
    { label: "BEC TOT", value: "BEC_TOT" },
    { label: "BEC + BEC TOT", value: "BEC_BEC_TOT" },
  ];
  const classTypeDropdownOptions = [
    { label: "Classic", value: "Classic" },
    { label: "Hybrid", value: "Hybrid" },
  ];
  const role = localStorage.getItem("role") as AdminRoles;
  const statusDropdownOptions = adminRoleStatusFilters?.[role] || [];
  const [courseFilterSearch, setCourseFilterSearch] = useState<string>("");

  const handleButtonClick = (e: React.MouseEvent<HTMLElement>) => {
    navigate("/create-course/classDetails");
  };

  const handleGoButtonClick = () => {
    setCourseType(filtercourseType);
    setStatusType(filterStatusType);
    setCollabOrg(collabOrganisation);
    setClassType(filterclassType);
    setCourseSearchTerm(courseFilterSearch);
    setCurrentPage(1);
  };

  const handleClearSearch = () => {
    setCourseFilterSearch("");
  };

  return (
    <div className="filter-section">
      <div className="container mt-4 pr-1">
        <div className="border-bottom pb-2 mb-3">
          <div className="row align-items-center">
            <div className="col-12 col-md-8 col-lg-9">
              <Headings size="h1" className={`mt-2 bordered pb-0`}>
                {role === AdminRoles.MasterTrainer
                  ? "Your courses"
                  : "Basic Emergency Care Course"}
              </Headings>
            </div>
            <div className="col-12 col-md-4 col-lg-3 d-flex justify-content-end">
              {canAccessCourse && (
                <button
                  className="btn btn-primary btn-md btn-round newCoursebtn"
                  onClick={handleButtonClick}
                  data-testid="new-course-id"
                >
                <aui-icon icon="plus" svgwidth="15" svgheight="15"></aui-icon> New
                course{" "}
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="dropdown-container">
          <div className="container">
            <div className="row">
              <div className="col-12 mb-3">
                <SearchInput
                  localSearchTerm={courseFilterSearch}
                  onClear={handleClearSearch}
                  setLocalSearchTerm={setCourseFilterSearch}
                  placeholder="Search by Reference ID, City or Country"
                />
              </div>
            </div>
            <div className="row align-items-end">
              <div className="col-12 col-md-10 col-lg-11 classtypeFilter">
                <div className="row align-items-end">
                  {canAccessOrg && (
                    <div className="col-12 col-md-3">
                      <OrganisationFilter
                        setCollabOrganisation={setCollabOrganisation}
                        data-testid="org-filter"
                        collabOrganisation={collabOrganisation}
                      />
                    </div>
                  )}
                  <div
                    className={`col-12 ${
                      canAccessOrg ? "col-md-3" : "col-md-4"
                    }`}
                  >
                    <DropDown
                      dropdownLabel="Course Type"
                      placeHolder="All courses"
                      data={courseDropdownOptions.map((v) => v.label)}
                      listInBtn
                      dropId = "coursetype"
                      onChange={(value: string) => {
                        const selectedOption = courseDropdownOptions.find(
                          (option) => option.label === value
                        );
                        if (selectedOption) {
                          setFiltercourseType(selectedOption);
                        } else {
                          setFiltercourseType({
                            label: "",
                            value: "",
                          });
                        }
                      }}
                    />
                  </div>
                  <div
                    className={`col-12 ${
                      canAccessOrg ? "col-md-3" : "col-md-4"
                    }`}
                  >
                    <DropDown
                      dropdownLabel="Class Type"
                      placeHolder="All types"
                      data={classTypeDropdownOptions.map((v) => v.label)}
                      listInBtn
                      dropId="classType"
                      onChange={(value: string) => {
                        const selectedOption = classTypeDropdownOptions.find(
                          (option) => option.label === value
                        );
                        if (selectedOption) {
                          setFilterclassType(selectedOption);
                        } else {
                          setFilterclassType({
                            label: "",
                            value: "",
                          });
                        }
                      }}
                    />
                  </div>
                  <div
                    className={`col-12 ${
                      canAccessOrg ? "col-md-3" : "col-md-4"
                    }`}
                  >
                    <DropDown
                      dropdownLabel="Status"
                      placeHolder="All status"
                      data={statusDropdownOptions.map((v) => v.label)}
                      listInBtn
                      dropId="status"
                      onChange={(value: string) => {
                        const selectedOption = statusDropdownOptions.find(
                          (option) => option.label === value
                        );
                        if (selectedOption) {
                          setFilterStatusType(selectedOption);
                        } else {
                          setFilterStatusType({
                            label: "",
                            value: "",
                          });
                        }
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-12 col-md-2 col-lg-1">
                <div className="row justify-content-end align-items-end btnGo py-3 py-md-0 pr-3 pr-md-2">
                  <AuiButton
                    variant="primary"
                    buttontitle="Go"
                    modalid="exampleModal"
                    type="button"
                    size="medium"
                    buttonid={""}
                    buttonClick={handleGoButtonClick}
                    data-testid="go-search-id"
                  ></AuiButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FilterSection;
